// Österreichische Steuernummer (9 Ziffern): erste 2 = FA-Dienststelle (BMF-Tabelle, Stand 01/2025)
export const FA_CODES = new Set([
  "03", "06", "07", "08", "09", "10", "11", "12", "15", "16", "22", "23", "29",
  "37", "38", "41", "46", "51", "52", "53", "54", "57", "61", "67", "68", "69",
  "71", "72", "81", "83", "84", "90", "91", "93", "98",
]);

export const stnrDigits = (v) => (v || "").replace(/\D/g, "");

// null = gültig, sonst Fehlermeldung
export const validateStnr = (v) => {
  const d = stnrDigits(v);
  if (d.length !== 9) return "Die Steuernummer muss 9 Ziffern haben (z. B. 03 123/4567).";
  if (!FA_CODES.has(d.slice(0, 2))) return `„${d.slice(0, 2)}“ ist keine gültige Finanzamtsnummer — bitte die ersten 2 Ziffern prüfen.`;
  return null;
};
